import {COMMON_MESSAGE} from '../constant/index';
export const commonMessageAction = data => {
  return {
    type: COMMON_MESSAGE,
    payload: data,
  };
};
